import PropTypes from 'prop-types';
import { Component, createRef } from 'react';
import { isBoolean } from 'lodash';

import { isValid } from 'components/utils/form-utils';
import { Colors } from 'components/utils/styles/ui';
import { Icon } from 'components/elements/icon';
import { ValidationErrorIndicator } from 'components/form/validationErrorIndicator';

import * as styled from './styles/checkbox';

export class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };
    this.inputRef = createRef();
  }

  componentDidMount() {
    this.updateIndeterminateState();
  }

  componentDidUpdate(prevProps) {
    const { indeterminate } = this.props;
    if (prevProps.indeterminate !== indeterminate) {
      this.updateIndeterminateState();
    }
  }

  updateIndeterminateState() {
    const { indeterminate } = this.props;
    if (this.inputRef.current) {
      this.inputRef.current.indeterminate = indeterminate || false;
    }
  }

  updateChecked() {
    const { id, checked, disabled, onChange } = this.props;

    if (!disabled) {
      onChange({ id, checked: !checked });
      this.setState({ focused: false });
    }
  }

  renderIcon() {
    const { checked, disabled, indeterminate } = this.props;

    if (indeterminate) {
      return (
        <Icon
          icon="Minus"
          size="large"
          weight="bold"
          color={disabled ? Colors.textLighter : Colors.white}
        />
      );
    }

    if (checked) {
      return (
        <Icon
          icon="Check"
          size="large"
          weight="bold"
          color={disabled ? Colors.textLighter : Colors.white}
        />
      );
    }

    return null;
  }

  render() {
    const {
      id,
      shouldValidate,
      inputType,
      required,
      checked,
      disabled,
      indeterminate,
      isCheckboxListValid,
      className,
      color,
    } = this.props;
    const { focused } = this.state;

    const isCheckboxValid = isBoolean(isCheckboxListValid)
      ? isCheckboxListValid
      : isValid({ inputValue: checked, shouldValidate, inputType, required });

    return (
      <styled.Checkbox
        checked={checked}
        indeterminate={indeterminate}
        disabled={disabled}
        focused={focused}
        isValid={isCheckboxValid}
        className={className}
        color={color}
        onClick={() => this.updateChecked()}
      >
        {shouldValidate && !isCheckboxValid && (
          <ValidationErrorIndicator inputType="checkbox" />
        )}

        <styled.CheckboxInput
          ref={this.inputRef}
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={() => this.updateChecked()}
          onFocus={() => this.setState({ focused: true })}
          onBlur={() => this.setState({ focused: false })}
        />
        <span>{this.renderIcon()}</span>
      </styled.Checkbox>
    );
  }
}

Checkbox.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  shouldValidate: PropTypes.bool,
  isCheckboxListValid: PropTypes.bool,
  inputType: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
};
